import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerItemData } from "@design-system/Picker/Picker.types";

export type MappedFilter = "all" | "mapped" | "unmapped";

const MAPPED_FILTER_LABELS: Record<MappedFilter, string> = {
    all: "All accounts",
    mapped: "Mapped",
    unmapped: "Unmapped",
};

const MAPPED_FILTER_OPTIONS: MappedFilter[] = ["all", "mapped", "unmapped"];

const MAPPED_FILTER_ITEMS: Array<PickerItemData<MappedFilter>> =
    MAPPED_FILTER_OPTIONS.map((option) => ({
        value: option,
        label: MAPPED_FILTER_LABELS[option],
    }));

interface Props {
    value: MappedFilter;
    onChange: (value: MappedFilter) => void;
}

export const CoaMappingPreviewMappedFilterCombobox = ({
    value,
    onChange,
}: Props) => (
    <Picker.Select
        items={MAPPED_FILTER_ITEMS}
        value={value}
        onValueChange={(nextValue) => onChange(nextValue ?? "all")}
    />
);
